/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as AuthLayoutRouteImport } from './routes/auth/_layout'
import { Route as AuthenticatedLayoutRouteImport } from './routes/_authenticated/_layout'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as InvitationInvitationIdRouteImport } from './routes/invitation/$invitationId'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthReviewerRouteImport } from './routes/auth/reviewer'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthActionRouteImport } from './routes/auth/action'
import { Route as AuthAccessDisabledRouteImport } from './routes/auth/access-disabled'
import { Route as AuthenticatedSuperadminLayoutRouteImport } from './routes/_authenticated/superadmin/_layout'
import { Route as AuthenticatedOnboardingLayoutRouteImport } from './routes/_authenticated/onboarding/_layout'
import { Route as AuthenticatedAppLayoutRouteImport } from './routes/_authenticated/_app/_layout'
import { Route as AuthenticatedSuperadminIndexRouteImport } from './routes/_authenticated/superadmin/index'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/_app/index'
import { Route as AuthenticatedSuperadminUsersRouteImport } from './routes/_authenticated/superadmin/users'
import { Route as AuthenticatedSuperadminOrganizationsRouteImport } from './routes/_authenticated/superadmin/organizations'
import { Route as AuthenticatedSuperadminBillingRouteImport } from './routes/_authenticated/superadmin/billing'
import { Route as AuthenticatedSuperadminAnalyticsRouteImport } from './routes/_authenticated/superadmin/analytics'
import { Route as AuthenticatedSuperadminActivityRouteImport } from './routes/_authenticated/superadmin/activity'
import { Route as AuthenticatedOnboardingBillingRouteImport } from './routes/_authenticated/onboarding/billing'
import { Route as AuthenticatedOnboardingStepRouteImport } from './routes/_authenticated/onboarding/$step'
import { Route as AuthenticatedBillingReturnRouteImport } from './routes/_authenticated/billing/return'
import { Route as AuthenticatedAppRecordsRouteImport } from './routes/_authenticated/_app/records'
import { Route as AuthenticatedAppPipelineRouteImport } from './routes/_authenticated/_app/pipeline'
import { Route as AuthenticatedAppAnalyticsRouteImport } from './routes/_authenticated/_app/analytics'
import { Route as AuthenticatedSuperadminSettingsLayoutRouteImport } from './routes/_authenticated/superadmin/settings/_layout'
import { Route as AuthenticatedAppSettingsLayoutRouteImport } from './routes/_authenticated/_app/settings/_layout'
import { Route as AuthenticatedAppImportLayoutRouteImport } from './routes/_authenticated/_app/import/_layout'
import { Route as AuthenticatedAppDatabaseLayoutRouteImport } from './routes/_authenticated/_app/database/_layout'
import { Route as AuthenticatedAppAgentsLayoutRouteImport } from './routes/_authenticated/_app/agents/_layout'
import { Route as AuthenticatedSuperadminSettingsIndexRouteImport } from './routes/_authenticated/superadmin/settings/index'
import { Route as AuthenticatedAppSettingsIndexRouteImport } from './routes/_authenticated/_app/settings/index'
import { Route as AuthenticatedAppImportIndexRouteImport } from './routes/_authenticated/_app/import/index'
import { Route as AuthenticatedAppDatabaseIndexRouteImport } from './routes/_authenticated/_app/database/index'
import { Route as AuthenticatedAppAgentsIndexRouteImport } from './routes/_authenticated/_app/agents/index'
import { Route as AuthenticatedSuperadminSettingsSecurityRouteImport } from './routes/_authenticated/superadmin/settings/security'
import { Route as AuthenticatedSuperadminSettingsProfileRouteImport } from './routes/_authenticated/superadmin/settings/profile'
import { Route as AuthenticatedAppSettingsTeamRouteImport } from './routes/_authenticated/_app/settings/team'
import { Route as AuthenticatedAppSettingsSecurityRouteImport } from './routes/_authenticated/_app/settings/security'
import { Route as AuthenticatedAppSettingsRolesRouteImport } from './routes/_authenticated/_app/settings/roles'
import { Route as AuthenticatedAppSettingsProfileRouteImport } from './routes/_authenticated/_app/settings/profile'
import { Route as AuthenticatedAppSettingsPhoneRouteImport } from './routes/_authenticated/_app/settings/phone'
import { Route as AuthenticatedAppSettingsPersonalAiPreferencesRouteImport } from './routes/_authenticated/_app/settings/personal-ai-preferences'
import { Route as AuthenticatedAppSettingsNotificationsRouteImport } from './routes/_authenticated/_app/settings/notifications'
import { Route as AuthenticatedAppSettingsMembershipRouteImport } from './routes/_authenticated/_app/settings/membership'
import { Route as AuthenticatedAppSettingsIntegrationsRouteImport } from './routes/_authenticated/_app/settings/integrations'
import { Route as AuthenticatedAppSettingsCustomFieldsRouteImport } from './routes/_authenticated/_app/settings/custom-fields'
import { Route as AuthenticatedAppSettingsConnectedAppsRouteImport } from './routes/_authenticated/_app/settings/connected-apps'
import { Route as AuthenticatedAppSettingsCompanyRouteImport } from './routes/_authenticated/_app/settings/company'
import { Route as AuthenticatedAppSettingsBillingRouteImport } from './routes/_authenticated/_app/settings/billing'
import { Route as AuthenticatedAppSettingsAuthorizedAppsRouteImport } from './routes/_authenticated/_app/settings/authorized-apps'
import { Route as AuthenticatedAppSettingsAiBehaviorRouteImport } from './routes/_authenticated/_app/settings/ai-behavior'
import { Route as AuthenticatedAppLeadsLeadIdRouteImport } from './routes/_authenticated/_app/leads/$leadId'
import { Route as AuthenticatedAppImportNewRouteImport } from './routes/_authenticated/_app/import/new'
import { Route as AuthenticatedAppImportImportJobIdRouteImport } from './routes/_authenticated/_app/import/$importJobId'
import { Route as AuthenticatedAppDatabaseSearchIdRouteImport } from './routes/_authenticated/_app/database/$searchId'
import { Route as AuthenticatedAppAgentsNewRouteImport } from './routes/_authenticated/_app/agents/new'
import { Route as AuthenticatedAppAgentsAgentIdRouteImport } from './routes/_authenticated/_app/agents/$agentId'
import { Route as AuthenticatedAppAgentsAgentIdIndexRouteImport } from './routes/_authenticated/_app/agents/$agentId/index'
import { Route as AuthenticatedAppAgentsAgentIdWebhookRouteImport } from './routes/_authenticated/_app/agents/$agentId/webhook'
import { Route as AuthenticatedAppAgentsAgentIdDeliveriesRouteImport } from './routes/_authenticated/_app/agents/$agentId/deliveries'
import { Route as AuthenticatedAppAgentsAgentIdActivityRouteImport } from './routes/_authenticated/_app/agents/$agentId/activity'
import { Route as AuthenticatedAppAgentsAgentIdActivityEntityIdRouteImport } from './routes/_authenticated/_app/agents/$agentId_.activity.$entityId'

const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLayoutRoute = AuthenticatedLayoutRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationInvitationIdRoute = InvitationInvitationIdRouteImport.update({
  id: '/invitation/$invitationId',
  path: '/invitation/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthReviewerRoute = AuthReviewerRouteImport.update({
  id: '/reviewer',
  path: '/reviewer',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthActionRoute = AuthActionRouteImport.update({
  id: '/action',
  path: '/action',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthAccessDisabledRoute = AuthAccessDisabledRouteImport.update({
  id: '/access-disabled',
  path: '/access-disabled',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthenticatedSuperadminLayoutRoute =
  AuthenticatedSuperadminLayoutRouteImport.update({
    id: '/superadmin',
    path: '/superadmin',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedOnboardingLayoutRoute =
  AuthenticatedOnboardingLayoutRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedAppLayoutRoute = AuthenticatedAppLayoutRouteImport.update({
  id: '/_app',
  getParentRoute: () => AuthenticatedLayoutRoute,
} as any)
const AuthenticatedSuperadminIndexRoute =
  AuthenticatedSuperadminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSuperadminLayoutRoute,
  } as any)
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAppLayoutRoute,
} as any)
const AuthenticatedSuperadminUsersRoute =
  AuthenticatedSuperadminUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedSuperadminLayoutRoute,
  } as any)
const AuthenticatedSuperadminOrganizationsRoute =
  AuthenticatedSuperadminOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedSuperadminLayoutRoute,
  } as any)
const AuthenticatedSuperadminBillingRoute =
  AuthenticatedSuperadminBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSuperadminLayoutRoute,
  } as any)
const AuthenticatedSuperadminAnalyticsRoute =
  AuthenticatedSuperadminAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedSuperadminLayoutRoute,
  } as any)
const AuthenticatedSuperadminActivityRoute =
  AuthenticatedSuperadminActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedSuperadminLayoutRoute,
  } as any)
const AuthenticatedOnboardingBillingRoute =
  AuthenticatedOnboardingBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedOnboardingLayoutRoute,
  } as any)
const AuthenticatedOnboardingStepRoute =
  AuthenticatedOnboardingStepRouteImport.update({
    id: '/$step',
    path: '/$step',
    getParentRoute: () => AuthenticatedOnboardingLayoutRoute,
  } as any)
const AuthenticatedBillingReturnRoute =
  AuthenticatedBillingReturnRouteImport.update({
    id: '/billing/return',
    path: '/billing/return',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedAppRecordsRoute = AuthenticatedAppRecordsRouteImport.update({
  id: '/records',
  path: '/records',
  getParentRoute: () => AuthenticatedAppLayoutRoute,
} as any)
const AuthenticatedAppPipelineRoute =
  AuthenticatedAppPipelineRouteImport.update({
    id: '/pipeline',
    path: '/pipeline',
    getParentRoute: () => AuthenticatedAppLayoutRoute,
  } as any)
const AuthenticatedAppAnalyticsRoute =
  AuthenticatedAppAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedAppLayoutRoute,
  } as any)
const AuthenticatedSuperadminSettingsLayoutRoute =
  AuthenticatedSuperadminSettingsLayoutRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedSuperadminLayoutRoute,
  } as any)
const AuthenticatedAppSettingsLayoutRoute =
  AuthenticatedAppSettingsLayoutRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAppLayoutRoute,
  } as any)
const AuthenticatedAppImportLayoutRoute =
  AuthenticatedAppImportLayoutRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedAppLayoutRoute,
  } as any)
const AuthenticatedAppDatabaseLayoutRoute =
  AuthenticatedAppDatabaseLayoutRouteImport.update({
    id: '/database',
    path: '/database',
    getParentRoute: () => AuthenticatedAppLayoutRoute,
  } as any)
const AuthenticatedAppAgentsLayoutRoute =
  AuthenticatedAppAgentsLayoutRouteImport.update({
    id: '/agents',
    path: '/agents',
    getParentRoute: () => AuthenticatedAppLayoutRoute,
  } as any)
const AuthenticatedSuperadminSettingsIndexRoute =
  AuthenticatedSuperadminSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSuperadminSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsIndexRoute =
  AuthenticatedAppSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppImportIndexRoute =
  AuthenticatedAppImportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppImportLayoutRoute,
  } as any)
const AuthenticatedAppDatabaseIndexRoute =
  AuthenticatedAppDatabaseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppDatabaseLayoutRoute,
  } as any)
const AuthenticatedAppAgentsIndexRoute =
  AuthenticatedAppAgentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppAgentsLayoutRoute,
  } as any)
const AuthenticatedSuperadminSettingsSecurityRoute =
  AuthenticatedSuperadminSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSuperadminSettingsLayoutRoute,
  } as any)
const AuthenticatedSuperadminSettingsProfileRoute =
  AuthenticatedSuperadminSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSuperadminSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsTeamRoute =
  AuthenticatedAppSettingsTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsSecurityRoute =
  AuthenticatedAppSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsRolesRoute =
  AuthenticatedAppSettingsRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsProfileRoute =
  AuthenticatedAppSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsPhoneRoute =
  AuthenticatedAppSettingsPhoneRouteImport.update({
    id: '/phone',
    path: '/phone',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsPersonalAiPreferencesRoute =
  AuthenticatedAppSettingsPersonalAiPreferencesRouteImport.update({
    id: '/personal-ai-preferences',
    path: '/personal-ai-preferences',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsNotificationsRoute =
  AuthenticatedAppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsMembershipRoute =
  AuthenticatedAppSettingsMembershipRouteImport.update({
    id: '/membership',
    path: '/membership',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsIntegrationsRoute =
  AuthenticatedAppSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsCustomFieldsRoute =
  AuthenticatedAppSettingsCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsConnectedAppsRoute =
  AuthenticatedAppSettingsConnectedAppsRouteImport.update({
    id: '/connected-apps',
    path: '/connected-apps',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsCompanyRoute =
  AuthenticatedAppSettingsCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsBillingRoute =
  AuthenticatedAppSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsAuthorizedAppsRoute =
  AuthenticatedAppSettingsAuthorizedAppsRouteImport.update({
    id: '/authorized-apps',
    path: '/authorized-apps',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppSettingsAiBehaviorRoute =
  AuthenticatedAppSettingsAiBehaviorRouteImport.update({
    id: '/ai-behavior',
    path: '/ai-behavior',
    getParentRoute: () => AuthenticatedAppSettingsLayoutRoute,
  } as any)
const AuthenticatedAppLeadsLeadIdRoute =
  AuthenticatedAppLeadsLeadIdRouteImport.update({
    id: '/leads/$leadId',
    path: '/leads/$leadId',
    getParentRoute: () => AuthenticatedAppLayoutRoute,
  } as any)
const AuthenticatedAppImportNewRoute =
  AuthenticatedAppImportNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAppImportLayoutRoute,
  } as any)
const AuthenticatedAppImportImportJobIdRoute =
  AuthenticatedAppImportImportJobIdRouteImport.update({
    id: '/$importJobId',
    path: '/$importJobId',
    getParentRoute: () => AuthenticatedAppImportLayoutRoute,
  } as any)
const AuthenticatedAppDatabaseSearchIdRoute =
  AuthenticatedAppDatabaseSearchIdRouteImport.update({
    id: '/$searchId',
    path: '/$searchId',
    getParentRoute: () => AuthenticatedAppDatabaseLayoutRoute,
  } as any)
const AuthenticatedAppAgentsNewRoute =
  AuthenticatedAppAgentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAppAgentsLayoutRoute,
  } as any)
const AuthenticatedAppAgentsAgentIdRoute =
  AuthenticatedAppAgentsAgentIdRouteImport.update({
    id: '/$agentId',
    path: '/$agentId',
    getParentRoute: () => AuthenticatedAppAgentsLayoutRoute,
  } as any)
const AuthenticatedAppAgentsAgentIdIndexRoute =
  AuthenticatedAppAgentsAgentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAppAgentsAgentIdRoute,
  } as any)
const AuthenticatedAppAgentsAgentIdWebhookRoute =
  AuthenticatedAppAgentsAgentIdWebhookRouteImport.update({
    id: '/webhook',
    path: '/webhook',
    getParentRoute: () => AuthenticatedAppAgentsAgentIdRoute,
  } as any)
const AuthenticatedAppAgentsAgentIdDeliveriesRoute =
  AuthenticatedAppAgentsAgentIdDeliveriesRouteImport.update({
    id: '/deliveries',
    path: '/deliveries',
    getParentRoute: () => AuthenticatedAppAgentsAgentIdRoute,
  } as any)
const AuthenticatedAppAgentsAgentIdActivityRoute =
  AuthenticatedAppAgentsAgentIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedAppAgentsAgentIdRoute,
  } as any)
const AuthenticatedAppAgentsAgentIdActivityEntityIdRoute =
  AuthenticatedAppAgentsAgentIdActivityEntityIdRouteImport.update({
    id: '/$agentId_/activity/$entityId',
    path: '/$agentId/activity/$entityId',
    getParentRoute: () => AuthenticatedAppAgentsLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedAppIndexRoute
  '/auth': typeof AuthLayoutRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/onboarding': typeof AuthenticatedOnboardingLayoutRouteWithChildren
  '/superadmin': typeof AuthenticatedSuperadminLayoutRouteWithChildren
  '/auth/access-disabled': typeof AuthAccessDisabledRoute
  '/auth/action': typeof AuthActionRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reviewer': typeof AuthReviewerRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/invitation/$invitationId': typeof InvitationInvitationIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/agents': typeof AuthenticatedAppAgentsLayoutRouteWithChildren
  '/database': typeof AuthenticatedAppDatabaseLayoutRouteWithChildren
  '/import': typeof AuthenticatedAppImportLayoutRouteWithChildren
  '/settings': typeof AuthenticatedAppSettingsLayoutRouteWithChildren
  '/superadmin/settings': typeof AuthenticatedSuperadminSettingsLayoutRouteWithChildren
  '/analytics': typeof AuthenticatedAppAnalyticsRoute
  '/pipeline': typeof AuthenticatedAppPipelineRoute
  '/records': typeof AuthenticatedAppRecordsRoute
  '/billing/return': typeof AuthenticatedBillingReturnRoute
  '/onboarding/$step': typeof AuthenticatedOnboardingStepRoute
  '/onboarding/billing': typeof AuthenticatedOnboardingBillingRoute
  '/superadmin/activity': typeof AuthenticatedSuperadminActivityRoute
  '/superadmin/analytics': typeof AuthenticatedSuperadminAnalyticsRoute
  '/superadmin/billing': typeof AuthenticatedSuperadminBillingRoute
  '/superadmin/organizations': typeof AuthenticatedSuperadminOrganizationsRoute
  '/superadmin/users': typeof AuthenticatedSuperadminUsersRoute
  '/superadmin/': typeof AuthenticatedSuperadminIndexRoute
  '/agents/$agentId': typeof AuthenticatedAppAgentsAgentIdRouteWithChildren
  '/agents/new': typeof AuthenticatedAppAgentsNewRoute
  '/database/$searchId': typeof AuthenticatedAppDatabaseSearchIdRoute
  '/import/$importJobId': typeof AuthenticatedAppImportImportJobIdRoute
  '/import/new': typeof AuthenticatedAppImportNewRoute
  '/leads/$leadId': typeof AuthenticatedAppLeadsLeadIdRoute
  '/settings/ai-behavior': typeof AuthenticatedAppSettingsAiBehaviorRoute
  '/settings/authorized-apps': typeof AuthenticatedAppSettingsAuthorizedAppsRoute
  '/settings/billing': typeof AuthenticatedAppSettingsBillingRoute
  '/settings/company': typeof AuthenticatedAppSettingsCompanyRoute
  '/settings/connected-apps': typeof AuthenticatedAppSettingsConnectedAppsRoute
  '/settings/custom-fields': typeof AuthenticatedAppSettingsCustomFieldsRoute
  '/settings/integrations': typeof AuthenticatedAppSettingsIntegrationsRoute
  '/settings/membership': typeof AuthenticatedAppSettingsMembershipRoute
  '/settings/notifications': typeof AuthenticatedAppSettingsNotificationsRoute
  '/settings/personal-ai-preferences': typeof AuthenticatedAppSettingsPersonalAiPreferencesRoute
  '/settings/phone': typeof AuthenticatedAppSettingsPhoneRoute
  '/settings/profile': typeof AuthenticatedAppSettingsProfileRoute
  '/settings/roles': typeof AuthenticatedAppSettingsRolesRoute
  '/settings/security': typeof AuthenticatedAppSettingsSecurityRoute
  '/settings/team': typeof AuthenticatedAppSettingsTeamRoute
  '/superadmin/settings/profile': typeof AuthenticatedSuperadminSettingsProfileRoute
  '/superadmin/settings/security': typeof AuthenticatedSuperadminSettingsSecurityRoute
  '/agents/': typeof AuthenticatedAppAgentsIndexRoute
  '/database/': typeof AuthenticatedAppDatabaseIndexRoute
  '/import/': typeof AuthenticatedAppImportIndexRoute
  '/settings/': typeof AuthenticatedAppSettingsIndexRoute
  '/superadmin/settings/': typeof AuthenticatedSuperadminSettingsIndexRoute
  '/agents/$agentId/activity': typeof AuthenticatedAppAgentsAgentIdActivityRoute
  '/agents/$agentId/deliveries': typeof AuthenticatedAppAgentsAgentIdDeliveriesRoute
  '/agents/$agentId/webhook': typeof AuthenticatedAppAgentsAgentIdWebhookRoute
  '/agents/$agentId/': typeof AuthenticatedAppAgentsAgentIdIndexRoute
  '/agents/$agentId/activity/$entityId': typeof AuthenticatedAppAgentsAgentIdActivityEntityIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedAppIndexRoute
  '/auth': typeof AuthLayoutRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/onboarding': typeof AuthenticatedOnboardingLayoutRouteWithChildren
  '/auth/access-disabled': typeof AuthAccessDisabledRoute
  '/auth/action': typeof AuthActionRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reviewer': typeof AuthReviewerRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/invitation/$invitationId': typeof InvitationInvitationIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/analytics': typeof AuthenticatedAppAnalyticsRoute
  '/pipeline': typeof AuthenticatedAppPipelineRoute
  '/records': typeof AuthenticatedAppRecordsRoute
  '/billing/return': typeof AuthenticatedBillingReturnRoute
  '/onboarding/$step': typeof AuthenticatedOnboardingStepRoute
  '/onboarding/billing': typeof AuthenticatedOnboardingBillingRoute
  '/superadmin/activity': typeof AuthenticatedSuperadminActivityRoute
  '/superadmin/analytics': typeof AuthenticatedSuperadminAnalyticsRoute
  '/superadmin/billing': typeof AuthenticatedSuperadminBillingRoute
  '/superadmin/organizations': typeof AuthenticatedSuperadminOrganizationsRoute
  '/superadmin/users': typeof AuthenticatedSuperadminUsersRoute
  '/superadmin': typeof AuthenticatedSuperadminIndexRoute
  '/agents/new': typeof AuthenticatedAppAgentsNewRoute
  '/database/$searchId': typeof AuthenticatedAppDatabaseSearchIdRoute
  '/import/$importJobId': typeof AuthenticatedAppImportImportJobIdRoute
  '/import/new': typeof AuthenticatedAppImportNewRoute
  '/leads/$leadId': typeof AuthenticatedAppLeadsLeadIdRoute
  '/settings/ai-behavior': typeof AuthenticatedAppSettingsAiBehaviorRoute
  '/settings/authorized-apps': typeof AuthenticatedAppSettingsAuthorizedAppsRoute
  '/settings/billing': typeof AuthenticatedAppSettingsBillingRoute
  '/settings/company': typeof AuthenticatedAppSettingsCompanyRoute
  '/settings/connected-apps': typeof AuthenticatedAppSettingsConnectedAppsRoute
  '/settings/custom-fields': typeof AuthenticatedAppSettingsCustomFieldsRoute
  '/settings/integrations': typeof AuthenticatedAppSettingsIntegrationsRoute
  '/settings/membership': typeof AuthenticatedAppSettingsMembershipRoute
  '/settings/notifications': typeof AuthenticatedAppSettingsNotificationsRoute
  '/settings/personal-ai-preferences': typeof AuthenticatedAppSettingsPersonalAiPreferencesRoute
  '/settings/phone': typeof AuthenticatedAppSettingsPhoneRoute
  '/settings/profile': typeof AuthenticatedAppSettingsProfileRoute
  '/settings/roles': typeof AuthenticatedAppSettingsRolesRoute
  '/settings/security': typeof AuthenticatedAppSettingsSecurityRoute
  '/settings/team': typeof AuthenticatedAppSettingsTeamRoute
  '/superadmin/settings/profile': typeof AuthenticatedSuperadminSettingsProfileRoute
  '/superadmin/settings/security': typeof AuthenticatedSuperadminSettingsSecurityRoute
  '/agents': typeof AuthenticatedAppAgentsIndexRoute
  '/database': typeof AuthenticatedAppDatabaseIndexRoute
  '/import': typeof AuthenticatedAppImportIndexRoute
  '/settings': typeof AuthenticatedAppSettingsIndexRoute
  '/superadmin/settings': typeof AuthenticatedSuperadminSettingsIndexRoute
  '/agents/$agentId/activity': typeof AuthenticatedAppAgentsAgentIdActivityRoute
  '/agents/$agentId/deliveries': typeof AuthenticatedAppAgentsAgentIdDeliveriesRoute
  '/agents/$agentId/webhook': typeof AuthenticatedAppAgentsAgentIdWebhookRoute
  '/agents/$agentId': typeof AuthenticatedAppAgentsAgentIdIndexRoute
  '/agents/$agentId/activity/$entityId': typeof AuthenticatedAppAgentsAgentIdActivityEntityIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedLayoutRouteWithChildren
  '/auth': typeof AuthLayoutRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/_authenticated/_app': typeof AuthenticatedAppLayoutRouteWithChildren
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingLayoutRouteWithChildren
  '/_authenticated/superadmin': typeof AuthenticatedSuperadminLayoutRouteWithChildren
  '/auth/access-disabled': typeof AuthAccessDisabledRoute
  '/auth/action': typeof AuthActionRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reviewer': typeof AuthReviewerRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/invitation/$invitationId': typeof InvitationInvitationIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/_authenticated/_app/agents': typeof AuthenticatedAppAgentsLayoutRouteWithChildren
  '/_authenticated/_app/database': typeof AuthenticatedAppDatabaseLayoutRouteWithChildren
  '/_authenticated/_app/import': typeof AuthenticatedAppImportLayoutRouteWithChildren
  '/_authenticated/_app/settings': typeof AuthenticatedAppSettingsLayoutRouteWithChildren
  '/_authenticated/superadmin/settings': typeof AuthenticatedSuperadminSettingsLayoutRouteWithChildren
  '/_authenticated/_app/analytics': typeof AuthenticatedAppAnalyticsRoute
  '/_authenticated/_app/pipeline': typeof AuthenticatedAppPipelineRoute
  '/_authenticated/_app/records': typeof AuthenticatedAppRecordsRoute
  '/_authenticated/billing/return': typeof AuthenticatedBillingReturnRoute
  '/_authenticated/onboarding/$step': typeof AuthenticatedOnboardingStepRoute
  '/_authenticated/onboarding/billing': typeof AuthenticatedOnboardingBillingRoute
  '/_authenticated/superadmin/activity': typeof AuthenticatedSuperadminActivityRoute
  '/_authenticated/superadmin/analytics': typeof AuthenticatedSuperadminAnalyticsRoute
  '/_authenticated/superadmin/billing': typeof AuthenticatedSuperadminBillingRoute
  '/_authenticated/superadmin/organizations': typeof AuthenticatedSuperadminOrganizationsRoute
  '/_authenticated/superadmin/users': typeof AuthenticatedSuperadminUsersRoute
  '/_authenticated/_app/': typeof AuthenticatedAppIndexRoute
  '/_authenticated/superadmin/': typeof AuthenticatedSuperadminIndexRoute
  '/_authenticated/_app/agents/$agentId': typeof AuthenticatedAppAgentsAgentIdRouteWithChildren
  '/_authenticated/_app/agents/new': typeof AuthenticatedAppAgentsNewRoute
  '/_authenticated/_app/database/$searchId': typeof AuthenticatedAppDatabaseSearchIdRoute
  '/_authenticated/_app/import/$importJobId': typeof AuthenticatedAppImportImportJobIdRoute
  '/_authenticated/_app/import/new': typeof AuthenticatedAppImportNewRoute
  '/_authenticated/_app/leads/$leadId': typeof AuthenticatedAppLeadsLeadIdRoute
  '/_authenticated/_app/settings/ai-behavior': typeof AuthenticatedAppSettingsAiBehaviorRoute
  '/_authenticated/_app/settings/authorized-apps': typeof AuthenticatedAppSettingsAuthorizedAppsRoute
  '/_authenticated/_app/settings/billing': typeof AuthenticatedAppSettingsBillingRoute
  '/_authenticated/_app/settings/company': typeof AuthenticatedAppSettingsCompanyRoute
  '/_authenticated/_app/settings/connected-apps': typeof AuthenticatedAppSettingsConnectedAppsRoute
  '/_authenticated/_app/settings/custom-fields': typeof AuthenticatedAppSettingsCustomFieldsRoute
  '/_authenticated/_app/settings/integrations': typeof AuthenticatedAppSettingsIntegrationsRoute
  '/_authenticated/_app/settings/membership': typeof AuthenticatedAppSettingsMembershipRoute
  '/_authenticated/_app/settings/notifications': typeof AuthenticatedAppSettingsNotificationsRoute
  '/_authenticated/_app/settings/personal-ai-preferences': typeof AuthenticatedAppSettingsPersonalAiPreferencesRoute
  '/_authenticated/_app/settings/phone': typeof AuthenticatedAppSettingsPhoneRoute
  '/_authenticated/_app/settings/profile': typeof AuthenticatedAppSettingsProfileRoute
  '/_authenticated/_app/settings/roles': typeof AuthenticatedAppSettingsRolesRoute
  '/_authenticated/_app/settings/security': typeof AuthenticatedAppSettingsSecurityRoute
  '/_authenticated/_app/settings/team': typeof AuthenticatedAppSettingsTeamRoute
  '/_authenticated/superadmin/settings/profile': typeof AuthenticatedSuperadminSettingsProfileRoute
  '/_authenticated/superadmin/settings/security': typeof AuthenticatedSuperadminSettingsSecurityRoute
  '/_authenticated/_app/agents/': typeof AuthenticatedAppAgentsIndexRoute
  '/_authenticated/_app/database/': typeof AuthenticatedAppDatabaseIndexRoute
  '/_authenticated/_app/import/': typeof AuthenticatedAppImportIndexRoute
  '/_authenticated/_app/settings/': typeof AuthenticatedAppSettingsIndexRoute
  '/_authenticated/superadmin/settings/': typeof AuthenticatedSuperadminSettingsIndexRoute
  '/_authenticated/_app/agents/$agentId/activity': typeof AuthenticatedAppAgentsAgentIdActivityRoute
  '/_authenticated/_app/agents/$agentId/deliveries': typeof AuthenticatedAppAgentsAgentIdDeliveriesRoute
  '/_authenticated/_app/agents/$agentId/webhook': typeof AuthenticatedAppAgentsAgentIdWebhookRoute
  '/_authenticated/_app/agents/$agentId/': typeof AuthenticatedAppAgentsAgentIdIndexRoute
  '/_authenticated/_app/agents/$agentId_/activity/$entityId': typeof AuthenticatedAppAgentsAgentIdActivityEntityIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/impersonate'
    | '/onboarding'
    | '/superadmin'
    | '/auth/access-disabled'
    | '/auth/action'
    | '/auth/forgot-password'
    | '/auth/reviewer'
    | '/auth/signin'
    | '/auth/signup'
    | '/invitation/$invitationId'
    | '/oauth/consent'
    | '/agents'
    | '/database'
    | '/import'
    | '/settings'
    | '/superadmin/settings'
    | '/analytics'
    | '/pipeline'
    | '/records'
    | '/billing/return'
    | '/onboarding/$step'
    | '/onboarding/billing'
    | '/superadmin/activity'
    | '/superadmin/analytics'
    | '/superadmin/billing'
    | '/superadmin/organizations'
    | '/superadmin/users'
    | '/superadmin/'
    | '/agents/$agentId'
    | '/agents/new'
    | '/database/$searchId'
    | '/import/$importJobId'
    | '/import/new'
    | '/leads/$leadId'
    | '/settings/ai-behavior'
    | '/settings/authorized-apps'
    | '/settings/billing'
    | '/settings/company'
    | '/settings/connected-apps'
    | '/settings/custom-fields'
    | '/settings/integrations'
    | '/settings/membership'
    | '/settings/notifications'
    | '/settings/personal-ai-preferences'
    | '/settings/phone'
    | '/settings/profile'
    | '/settings/roles'
    | '/settings/security'
    | '/settings/team'
    | '/superadmin/settings/profile'
    | '/superadmin/settings/security'
    | '/agents/'
    | '/database/'
    | '/import/'
    | '/settings/'
    | '/superadmin/settings/'
    | '/agents/$agentId/activity'
    | '/agents/$agentId/deliveries'
    | '/agents/$agentId/webhook'
    | '/agents/$agentId/'
    | '/agents/$agentId/activity/$entityId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/impersonate'
    | '/onboarding'
    | '/auth/access-disabled'
    | '/auth/action'
    | '/auth/forgot-password'
    | '/auth/reviewer'
    | '/auth/signin'
    | '/auth/signup'
    | '/invitation/$invitationId'
    | '/oauth/consent'
    | '/analytics'
    | '/pipeline'
    | '/records'
    | '/billing/return'
    | '/onboarding/$step'
    | '/onboarding/billing'
    | '/superadmin/activity'
    | '/superadmin/analytics'
    | '/superadmin/billing'
    | '/superadmin/organizations'
    | '/superadmin/users'
    | '/superadmin'
    | '/agents/new'
    | '/database/$searchId'
    | '/import/$importJobId'
    | '/import/new'
    | '/leads/$leadId'
    | '/settings/ai-behavior'
    | '/settings/authorized-apps'
    | '/settings/billing'
    | '/settings/company'
    | '/settings/connected-apps'
    | '/settings/custom-fields'
    | '/settings/integrations'
    | '/settings/membership'
    | '/settings/notifications'
    | '/settings/personal-ai-preferences'
    | '/settings/phone'
    | '/settings/profile'
    | '/settings/roles'
    | '/settings/security'
    | '/settings/team'
    | '/superadmin/settings/profile'
    | '/superadmin/settings/security'
    | '/agents'
    | '/database'
    | '/import'
    | '/settings'
    | '/superadmin/settings'
    | '/agents/$agentId/activity'
    | '/agents/$agentId/deliveries'
    | '/agents/$agentId/webhook'
    | '/agents/$agentId'
    | '/agents/$agentId/activity/$entityId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/auth'
    | '/impersonate'
    | '/_authenticated/_app'
    | '/_authenticated/onboarding'
    | '/_authenticated/superadmin'
    | '/auth/access-disabled'
    | '/auth/action'
    | '/auth/forgot-password'
    | '/auth/reviewer'
    | '/auth/signin'
    | '/auth/signup'
    | '/invitation/$invitationId'
    | '/oauth/consent'
    | '/_authenticated/_app/agents'
    | '/_authenticated/_app/database'
    | '/_authenticated/_app/import'
    | '/_authenticated/_app/settings'
    | '/_authenticated/superadmin/settings'
    | '/_authenticated/_app/analytics'
    | '/_authenticated/_app/pipeline'
    | '/_authenticated/_app/records'
    | '/_authenticated/billing/return'
    | '/_authenticated/onboarding/$step'
    | '/_authenticated/onboarding/billing'
    | '/_authenticated/superadmin/activity'
    | '/_authenticated/superadmin/analytics'
    | '/_authenticated/superadmin/billing'
    | '/_authenticated/superadmin/organizations'
    | '/_authenticated/superadmin/users'
    | '/_authenticated/_app/'
    | '/_authenticated/superadmin/'
    | '/_authenticated/_app/agents/$agentId'
    | '/_authenticated/_app/agents/new'
    | '/_authenticated/_app/database/$searchId'
    | '/_authenticated/_app/import/$importJobId'
    | '/_authenticated/_app/import/new'
    | '/_authenticated/_app/leads/$leadId'
    | '/_authenticated/_app/settings/ai-behavior'
    | '/_authenticated/_app/settings/authorized-apps'
    | '/_authenticated/_app/settings/billing'
    | '/_authenticated/_app/settings/company'
    | '/_authenticated/_app/settings/connected-apps'
    | '/_authenticated/_app/settings/custom-fields'
    | '/_authenticated/_app/settings/integrations'
    | '/_authenticated/_app/settings/membership'
    | '/_authenticated/_app/settings/notifications'
    | '/_authenticated/_app/settings/personal-ai-preferences'
    | '/_authenticated/_app/settings/phone'
    | '/_authenticated/_app/settings/profile'
    | '/_authenticated/_app/settings/roles'
    | '/_authenticated/_app/settings/security'
    | '/_authenticated/_app/settings/team'
    | '/_authenticated/superadmin/settings/profile'
    | '/_authenticated/superadmin/settings/security'
    | '/_authenticated/_app/agents/'
    | '/_authenticated/_app/database/'
    | '/_authenticated/_app/import/'
    | '/_authenticated/_app/settings/'
    | '/_authenticated/superadmin/settings/'
    | '/_authenticated/_app/agents/$agentId/activity'
    | '/_authenticated/_app/agents/$agentId/deliveries'
    | '/_authenticated/_app/agents/$agentId/webhook'
    | '/_authenticated/_app/agents/$agentId/'
    | '/_authenticated/_app/agents/$agentId_/activity/$entityId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedLayoutRoute: typeof AuthenticatedLayoutRouteWithChildren
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  ImpersonateRoute: typeof ImpersonateRoute
  InvitationInvitationIdRoute: typeof InvitationInvitationIdRoute
  OauthConsentRoute: typeof OauthConsentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation/$invitationId': {
      id: '/invitation/$invitationId'
      path: '/invitation/$invitationId'
      fullPath: '/invitation/$invitationId'
      preLoaderRoute: typeof InvitationInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/auth/reviewer': {
      id: '/auth/reviewer'
      path: '/reviewer'
      fullPath: '/auth/reviewer'
      preLoaderRoute: typeof AuthReviewerRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/auth/action': {
      id: '/auth/action'
      path: '/action'
      fullPath: '/auth/action'
      preLoaderRoute: typeof AuthActionRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/auth/access-disabled': {
      id: '/auth/access-disabled'
      path: '/access-disabled'
      fullPath: '/auth/access-disabled'
      preLoaderRoute: typeof AuthAccessDisabledRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authenticated/superadmin': {
      id: '/_authenticated/superadmin'
      path: '/superadmin'
      fullPath: '/superadmin'
      preLoaderRoute: typeof AuthenticatedSuperadminLayoutRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingLayoutRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_app': {
      id: '/_authenticated/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedAppLayoutRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/superadmin/': {
      id: '/_authenticated/superadmin/'
      path: '/'
      fullPath: '/superadmin/'
      preLoaderRoute: typeof AuthenticatedSuperadminIndexRouteImport
      parentRoute: typeof AuthenticatedSuperadminLayoutRoute
    }
    '/_authenticated/_app/': {
      id: '/_authenticated/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedAppIndexRouteImport
      parentRoute: typeof AuthenticatedAppLayoutRoute
    }
    '/_authenticated/superadmin/users': {
      id: '/_authenticated/superadmin/users'
      path: '/users'
      fullPath: '/superadmin/users'
      preLoaderRoute: typeof AuthenticatedSuperadminUsersRouteImport
      parentRoute: typeof AuthenticatedSuperadminLayoutRoute
    }
    '/_authenticated/superadmin/organizations': {
      id: '/_authenticated/superadmin/organizations'
      path: '/organizations'
      fullPath: '/superadmin/organizations'
      preLoaderRoute: typeof AuthenticatedSuperadminOrganizationsRouteImport
      parentRoute: typeof AuthenticatedSuperadminLayoutRoute
    }
    '/_authenticated/superadmin/billing': {
      id: '/_authenticated/superadmin/billing'
      path: '/billing'
      fullPath: '/superadmin/billing'
      preLoaderRoute: typeof AuthenticatedSuperadminBillingRouteImport
      parentRoute: typeof AuthenticatedSuperadminLayoutRoute
    }
    '/_authenticated/superadmin/analytics': {
      id: '/_authenticated/superadmin/analytics'
      path: '/analytics'
      fullPath: '/superadmin/analytics'
      preLoaderRoute: typeof AuthenticatedSuperadminAnalyticsRouteImport
      parentRoute: typeof AuthenticatedSuperadminLayoutRoute
    }
    '/_authenticated/superadmin/activity': {
      id: '/_authenticated/superadmin/activity'
      path: '/activity'
      fullPath: '/superadmin/activity'
      preLoaderRoute: typeof AuthenticatedSuperadminActivityRouteImport
      parentRoute: typeof AuthenticatedSuperadminLayoutRoute
    }
    '/_authenticated/onboarding/billing': {
      id: '/_authenticated/onboarding/billing'
      path: '/billing'
      fullPath: '/onboarding/billing'
      preLoaderRoute: typeof AuthenticatedOnboardingBillingRouteImport
      parentRoute: typeof AuthenticatedOnboardingLayoutRoute
    }
    '/_authenticated/onboarding/$step': {
      id: '/_authenticated/onboarding/$step'
      path: '/$step'
      fullPath: '/onboarding/$step'
      preLoaderRoute: typeof AuthenticatedOnboardingStepRouteImport
      parentRoute: typeof AuthenticatedOnboardingLayoutRoute
    }
    '/_authenticated/billing/return': {
      id: '/_authenticated/billing/return'
      path: '/billing/return'
      fullPath: '/billing/return'
      preLoaderRoute: typeof AuthenticatedBillingReturnRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_app/records': {
      id: '/_authenticated/_app/records'
      path: '/records'
      fullPath: '/records'
      preLoaderRoute: typeof AuthenticatedAppRecordsRouteImport
      parentRoute: typeof AuthenticatedAppLayoutRoute
    }
    '/_authenticated/_app/pipeline': {
      id: '/_authenticated/_app/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof AuthenticatedAppPipelineRouteImport
      parentRoute: typeof AuthenticatedAppLayoutRoute
    }
    '/_authenticated/_app/analytics': {
      id: '/_authenticated/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAppAnalyticsRouteImport
      parentRoute: typeof AuthenticatedAppLayoutRoute
    }
    '/_authenticated/superadmin/settings': {
      id: '/_authenticated/superadmin/settings'
      path: '/settings'
      fullPath: '/superadmin/settings'
      preLoaderRoute: typeof AuthenticatedSuperadminSettingsLayoutRouteImport
      parentRoute: typeof AuthenticatedSuperadminLayoutRoute
    }
    '/_authenticated/_app/settings': {
      id: '/_authenticated/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedAppSettingsLayoutRouteImport
      parentRoute: typeof AuthenticatedAppLayoutRoute
    }
    '/_authenticated/_app/import': {
      id: '/_authenticated/_app/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AuthenticatedAppImportLayoutRouteImport
      parentRoute: typeof AuthenticatedAppLayoutRoute
    }
    '/_authenticated/_app/database': {
      id: '/_authenticated/_app/database'
      path: '/database'
      fullPath: '/database'
      preLoaderRoute: typeof AuthenticatedAppDatabaseLayoutRouteImport
      parentRoute: typeof AuthenticatedAppLayoutRoute
    }
    '/_authenticated/_app/agents': {
      id: '/_authenticated/_app/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AuthenticatedAppAgentsLayoutRouteImport
      parentRoute: typeof AuthenticatedAppLayoutRoute
    }
    '/_authenticated/superadmin/settings/': {
      id: '/_authenticated/superadmin/settings/'
      path: '/'
      fullPath: '/superadmin/settings/'
      preLoaderRoute: typeof AuthenticatedSuperadminSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSuperadminSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/': {
      id: '/_authenticated/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedAppSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/import/': {
      id: '/_authenticated/_app/import/'
      path: '/'
      fullPath: '/import/'
      preLoaderRoute: typeof AuthenticatedAppImportIndexRouteImport
      parentRoute: typeof AuthenticatedAppImportLayoutRoute
    }
    '/_authenticated/_app/database/': {
      id: '/_authenticated/_app/database/'
      path: '/'
      fullPath: '/database/'
      preLoaderRoute: typeof AuthenticatedAppDatabaseIndexRouteImport
      parentRoute: typeof AuthenticatedAppDatabaseLayoutRoute
    }
    '/_authenticated/_app/agents/': {
      id: '/_authenticated/_app/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthenticatedAppAgentsIndexRouteImport
      parentRoute: typeof AuthenticatedAppAgentsLayoutRoute
    }
    '/_authenticated/superadmin/settings/security': {
      id: '/_authenticated/superadmin/settings/security'
      path: '/security'
      fullPath: '/superadmin/settings/security'
      preLoaderRoute: typeof AuthenticatedSuperadminSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedSuperadminSettingsLayoutRoute
    }
    '/_authenticated/superadmin/settings/profile': {
      id: '/_authenticated/superadmin/settings/profile'
      path: '/profile'
      fullPath: '/superadmin/settings/profile'
      preLoaderRoute: typeof AuthenticatedSuperadminSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedSuperadminSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/team': {
      id: '/_authenticated/_app/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthenticatedAppSettingsTeamRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/security': {
      id: '/_authenticated/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedAppSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/roles': {
      id: '/_authenticated/_app/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthenticatedAppSettingsRolesRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/profile': {
      id: '/_authenticated/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedAppSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/phone': {
      id: '/_authenticated/_app/settings/phone'
      path: '/phone'
      fullPath: '/settings/phone'
      preLoaderRoute: typeof AuthenticatedAppSettingsPhoneRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/personal-ai-preferences': {
      id: '/_authenticated/_app/settings/personal-ai-preferences'
      path: '/personal-ai-preferences'
      fullPath: '/settings/personal-ai-preferences'
      preLoaderRoute: typeof AuthenticatedAppSettingsPersonalAiPreferencesRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/notifications': {
      id: '/_authenticated/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedAppSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/membership': {
      id: '/_authenticated/_app/settings/membership'
      path: '/membership'
      fullPath: '/settings/membership'
      preLoaderRoute: typeof AuthenticatedAppSettingsMembershipRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/integrations': {
      id: '/_authenticated/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthenticatedAppSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/custom-fields': {
      id: '/_authenticated/_app/settings/custom-fields'
      path: '/custom-fields'
      fullPath: '/settings/custom-fields'
      preLoaderRoute: typeof AuthenticatedAppSettingsCustomFieldsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/connected-apps': {
      id: '/_authenticated/_app/settings/connected-apps'
      path: '/connected-apps'
      fullPath: '/settings/connected-apps'
      preLoaderRoute: typeof AuthenticatedAppSettingsConnectedAppsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/company': {
      id: '/_authenticated/_app/settings/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AuthenticatedAppSettingsCompanyRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/billing': {
      id: '/_authenticated/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedAppSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/authorized-apps': {
      id: '/_authenticated/_app/settings/authorized-apps'
      path: '/authorized-apps'
      fullPath: '/settings/authorized-apps'
      preLoaderRoute: typeof AuthenticatedAppSettingsAuthorizedAppsRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/settings/ai-behavior': {
      id: '/_authenticated/_app/settings/ai-behavior'
      path: '/ai-behavior'
      fullPath: '/settings/ai-behavior'
      preLoaderRoute: typeof AuthenticatedAppSettingsAiBehaviorRouteImport
      parentRoute: typeof AuthenticatedAppSettingsLayoutRoute
    }
    '/_authenticated/_app/leads/$leadId': {
      id: '/_authenticated/_app/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof AuthenticatedAppLeadsLeadIdRouteImport
      parentRoute: typeof AuthenticatedAppLayoutRoute
    }
    '/_authenticated/_app/import/new': {
      id: '/_authenticated/_app/import/new'
      path: '/new'
      fullPath: '/import/new'
      preLoaderRoute: typeof AuthenticatedAppImportNewRouteImport
      parentRoute: typeof AuthenticatedAppImportLayoutRoute
    }
    '/_authenticated/_app/import/$importJobId': {
      id: '/_authenticated/_app/import/$importJobId'
      path: '/$importJobId'
      fullPath: '/import/$importJobId'
      preLoaderRoute: typeof AuthenticatedAppImportImportJobIdRouteImport
      parentRoute: typeof AuthenticatedAppImportLayoutRoute
    }
    '/_authenticated/_app/database/$searchId': {
      id: '/_authenticated/_app/database/$searchId'
      path: '/$searchId'
      fullPath: '/database/$searchId'
      preLoaderRoute: typeof AuthenticatedAppDatabaseSearchIdRouteImport
      parentRoute: typeof AuthenticatedAppDatabaseLayoutRoute
    }
    '/_authenticated/_app/agents/new': {
      id: '/_authenticated/_app/agents/new'
      path: '/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AuthenticatedAppAgentsNewRouteImport
      parentRoute: typeof AuthenticatedAppAgentsLayoutRoute
    }
    '/_authenticated/_app/agents/$agentId': {
      id: '/_authenticated/_app/agents/$agentId'
      path: '/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthenticatedAppAgentsAgentIdRouteImport
      parentRoute: typeof AuthenticatedAppAgentsLayoutRoute
    }
    '/_authenticated/_app/agents/$agentId/': {
      id: '/_authenticated/_app/agents/$agentId/'
      path: '/'
      fullPath: '/agents/$agentId/'
      preLoaderRoute: typeof AuthenticatedAppAgentsAgentIdIndexRouteImport
      parentRoute: typeof AuthenticatedAppAgentsAgentIdRoute
    }
    '/_authenticated/_app/agents/$agentId/webhook': {
      id: '/_authenticated/_app/agents/$agentId/webhook'
      path: '/webhook'
      fullPath: '/agents/$agentId/webhook'
      preLoaderRoute: typeof AuthenticatedAppAgentsAgentIdWebhookRouteImport
      parentRoute: typeof AuthenticatedAppAgentsAgentIdRoute
    }
    '/_authenticated/_app/agents/$agentId/deliveries': {
      id: '/_authenticated/_app/agents/$agentId/deliveries'
      path: '/deliveries'
      fullPath: '/agents/$agentId/deliveries'
      preLoaderRoute: typeof AuthenticatedAppAgentsAgentIdDeliveriesRouteImport
      parentRoute: typeof AuthenticatedAppAgentsAgentIdRoute
    }
    '/_authenticated/_app/agents/$agentId/activity': {
      id: '/_authenticated/_app/agents/$agentId/activity'
      path: '/activity'
      fullPath: '/agents/$agentId/activity'
      preLoaderRoute: typeof AuthenticatedAppAgentsAgentIdActivityRouteImport
      parentRoute: typeof AuthenticatedAppAgentsAgentIdRoute
    }
    '/_authenticated/_app/agents/$agentId_/activity/$entityId': {
      id: '/_authenticated/_app/agents/$agentId_/activity/$entityId'
      path: '/$agentId/activity/$entityId'
      fullPath: '/agents/$agentId/activity/$entityId'
      preLoaderRoute: typeof AuthenticatedAppAgentsAgentIdActivityEntityIdRouteImport
      parentRoute: typeof AuthenticatedAppAgentsLayoutRoute
    }
  }
}

interface AuthenticatedAppAgentsAgentIdRouteChildren {
  AuthenticatedAppAgentsAgentIdActivityRoute: typeof AuthenticatedAppAgentsAgentIdActivityRoute
  AuthenticatedAppAgentsAgentIdDeliveriesRoute: typeof AuthenticatedAppAgentsAgentIdDeliveriesRoute
  AuthenticatedAppAgentsAgentIdWebhookRoute: typeof AuthenticatedAppAgentsAgentIdWebhookRoute
  AuthenticatedAppAgentsAgentIdIndexRoute: typeof AuthenticatedAppAgentsAgentIdIndexRoute
}

const AuthenticatedAppAgentsAgentIdRouteChildren: AuthenticatedAppAgentsAgentIdRouteChildren =
  {
    AuthenticatedAppAgentsAgentIdActivityRoute:
      AuthenticatedAppAgentsAgentIdActivityRoute,
    AuthenticatedAppAgentsAgentIdDeliveriesRoute:
      AuthenticatedAppAgentsAgentIdDeliveriesRoute,
    AuthenticatedAppAgentsAgentIdWebhookRoute:
      AuthenticatedAppAgentsAgentIdWebhookRoute,
    AuthenticatedAppAgentsAgentIdIndexRoute:
      AuthenticatedAppAgentsAgentIdIndexRoute,
  }

const AuthenticatedAppAgentsAgentIdRouteWithChildren =
  AuthenticatedAppAgentsAgentIdRoute._addFileChildren(
    AuthenticatedAppAgentsAgentIdRouteChildren,
  )

interface AuthenticatedAppAgentsLayoutRouteChildren {
  AuthenticatedAppAgentsAgentIdRoute: typeof AuthenticatedAppAgentsAgentIdRouteWithChildren
  AuthenticatedAppAgentsNewRoute: typeof AuthenticatedAppAgentsNewRoute
  AuthenticatedAppAgentsIndexRoute: typeof AuthenticatedAppAgentsIndexRoute
  AuthenticatedAppAgentsAgentIdActivityEntityIdRoute: typeof AuthenticatedAppAgentsAgentIdActivityEntityIdRoute
}

const AuthenticatedAppAgentsLayoutRouteChildren: AuthenticatedAppAgentsLayoutRouteChildren =
  {
    AuthenticatedAppAgentsAgentIdRoute:
      AuthenticatedAppAgentsAgentIdRouteWithChildren,
    AuthenticatedAppAgentsNewRoute: AuthenticatedAppAgentsNewRoute,
    AuthenticatedAppAgentsIndexRoute: AuthenticatedAppAgentsIndexRoute,
    AuthenticatedAppAgentsAgentIdActivityEntityIdRoute:
      AuthenticatedAppAgentsAgentIdActivityEntityIdRoute,
  }

const AuthenticatedAppAgentsLayoutRouteWithChildren =
  AuthenticatedAppAgentsLayoutRoute._addFileChildren(
    AuthenticatedAppAgentsLayoutRouteChildren,
  )

interface AuthenticatedAppDatabaseLayoutRouteChildren {
  AuthenticatedAppDatabaseSearchIdRoute: typeof AuthenticatedAppDatabaseSearchIdRoute
  AuthenticatedAppDatabaseIndexRoute: typeof AuthenticatedAppDatabaseIndexRoute
}

const AuthenticatedAppDatabaseLayoutRouteChildren: AuthenticatedAppDatabaseLayoutRouteChildren =
  {
    AuthenticatedAppDatabaseSearchIdRoute:
      AuthenticatedAppDatabaseSearchIdRoute,
    AuthenticatedAppDatabaseIndexRoute: AuthenticatedAppDatabaseIndexRoute,
  }

const AuthenticatedAppDatabaseLayoutRouteWithChildren =
  AuthenticatedAppDatabaseLayoutRoute._addFileChildren(
    AuthenticatedAppDatabaseLayoutRouteChildren,
  )

interface AuthenticatedAppImportLayoutRouteChildren {
  AuthenticatedAppImportImportJobIdRoute: typeof AuthenticatedAppImportImportJobIdRoute
  AuthenticatedAppImportNewRoute: typeof AuthenticatedAppImportNewRoute
  AuthenticatedAppImportIndexRoute: typeof AuthenticatedAppImportIndexRoute
}

const AuthenticatedAppImportLayoutRouteChildren: AuthenticatedAppImportLayoutRouteChildren =
  {
    AuthenticatedAppImportImportJobIdRoute:
      AuthenticatedAppImportImportJobIdRoute,
    AuthenticatedAppImportNewRoute: AuthenticatedAppImportNewRoute,
    AuthenticatedAppImportIndexRoute: AuthenticatedAppImportIndexRoute,
  }

const AuthenticatedAppImportLayoutRouteWithChildren =
  AuthenticatedAppImportLayoutRoute._addFileChildren(
    AuthenticatedAppImportLayoutRouteChildren,
  )

interface AuthenticatedAppSettingsLayoutRouteChildren {
  AuthenticatedAppSettingsAiBehaviorRoute: typeof AuthenticatedAppSettingsAiBehaviorRoute
  AuthenticatedAppSettingsAuthorizedAppsRoute: typeof AuthenticatedAppSettingsAuthorizedAppsRoute
  AuthenticatedAppSettingsBillingRoute: typeof AuthenticatedAppSettingsBillingRoute
  AuthenticatedAppSettingsCompanyRoute: typeof AuthenticatedAppSettingsCompanyRoute
  AuthenticatedAppSettingsConnectedAppsRoute: typeof AuthenticatedAppSettingsConnectedAppsRoute
  AuthenticatedAppSettingsCustomFieldsRoute: typeof AuthenticatedAppSettingsCustomFieldsRoute
  AuthenticatedAppSettingsIntegrationsRoute: typeof AuthenticatedAppSettingsIntegrationsRoute
  AuthenticatedAppSettingsMembershipRoute: typeof AuthenticatedAppSettingsMembershipRoute
  AuthenticatedAppSettingsNotificationsRoute: typeof AuthenticatedAppSettingsNotificationsRoute
  AuthenticatedAppSettingsPersonalAiPreferencesRoute: typeof AuthenticatedAppSettingsPersonalAiPreferencesRoute
  AuthenticatedAppSettingsPhoneRoute: typeof AuthenticatedAppSettingsPhoneRoute
  AuthenticatedAppSettingsProfileRoute: typeof AuthenticatedAppSettingsProfileRoute
  AuthenticatedAppSettingsRolesRoute: typeof AuthenticatedAppSettingsRolesRoute
  AuthenticatedAppSettingsSecurityRoute: typeof AuthenticatedAppSettingsSecurityRoute
  AuthenticatedAppSettingsTeamRoute: typeof AuthenticatedAppSettingsTeamRoute
  AuthenticatedAppSettingsIndexRoute: typeof AuthenticatedAppSettingsIndexRoute
}

const AuthenticatedAppSettingsLayoutRouteChildren: AuthenticatedAppSettingsLayoutRouteChildren =
  {
    AuthenticatedAppSettingsAiBehaviorRoute:
      AuthenticatedAppSettingsAiBehaviorRoute,
    AuthenticatedAppSettingsAuthorizedAppsRoute:
      AuthenticatedAppSettingsAuthorizedAppsRoute,
    AuthenticatedAppSettingsBillingRoute: AuthenticatedAppSettingsBillingRoute,
    AuthenticatedAppSettingsCompanyRoute: AuthenticatedAppSettingsCompanyRoute,
    AuthenticatedAppSettingsConnectedAppsRoute:
      AuthenticatedAppSettingsConnectedAppsRoute,
    AuthenticatedAppSettingsCustomFieldsRoute:
      AuthenticatedAppSettingsCustomFieldsRoute,
    AuthenticatedAppSettingsIntegrationsRoute:
      AuthenticatedAppSettingsIntegrationsRoute,
    AuthenticatedAppSettingsMembershipRoute:
      AuthenticatedAppSettingsMembershipRoute,
    AuthenticatedAppSettingsNotificationsRoute:
      AuthenticatedAppSettingsNotificationsRoute,
    AuthenticatedAppSettingsPersonalAiPreferencesRoute:
      AuthenticatedAppSettingsPersonalAiPreferencesRoute,
    AuthenticatedAppSettingsPhoneRoute: AuthenticatedAppSettingsPhoneRoute,
    AuthenticatedAppSettingsProfileRoute: AuthenticatedAppSettingsProfileRoute,
    AuthenticatedAppSettingsRolesRoute: AuthenticatedAppSettingsRolesRoute,
    AuthenticatedAppSettingsSecurityRoute:
      AuthenticatedAppSettingsSecurityRoute,
    AuthenticatedAppSettingsTeamRoute: AuthenticatedAppSettingsTeamRoute,
    AuthenticatedAppSettingsIndexRoute: AuthenticatedAppSettingsIndexRoute,
  }

const AuthenticatedAppSettingsLayoutRouteWithChildren =
  AuthenticatedAppSettingsLayoutRoute._addFileChildren(
    AuthenticatedAppSettingsLayoutRouteChildren,
  )

interface AuthenticatedAppLayoutRouteChildren {
  AuthenticatedAppAgentsLayoutRoute: typeof AuthenticatedAppAgentsLayoutRouteWithChildren
  AuthenticatedAppDatabaseLayoutRoute: typeof AuthenticatedAppDatabaseLayoutRouteWithChildren
  AuthenticatedAppImportLayoutRoute: typeof AuthenticatedAppImportLayoutRouteWithChildren
  AuthenticatedAppSettingsLayoutRoute: typeof AuthenticatedAppSettingsLayoutRouteWithChildren
  AuthenticatedAppAnalyticsRoute: typeof AuthenticatedAppAnalyticsRoute
  AuthenticatedAppPipelineRoute: typeof AuthenticatedAppPipelineRoute
  AuthenticatedAppRecordsRoute: typeof AuthenticatedAppRecordsRoute
  AuthenticatedAppIndexRoute: typeof AuthenticatedAppIndexRoute
  AuthenticatedAppLeadsLeadIdRoute: typeof AuthenticatedAppLeadsLeadIdRoute
}

const AuthenticatedAppLayoutRouteChildren: AuthenticatedAppLayoutRouteChildren =
  {
    AuthenticatedAppAgentsLayoutRoute:
      AuthenticatedAppAgentsLayoutRouteWithChildren,
    AuthenticatedAppDatabaseLayoutRoute:
      AuthenticatedAppDatabaseLayoutRouteWithChildren,
    AuthenticatedAppImportLayoutRoute:
      AuthenticatedAppImportLayoutRouteWithChildren,
    AuthenticatedAppSettingsLayoutRoute:
      AuthenticatedAppSettingsLayoutRouteWithChildren,
    AuthenticatedAppAnalyticsRoute: AuthenticatedAppAnalyticsRoute,
    AuthenticatedAppPipelineRoute: AuthenticatedAppPipelineRoute,
    AuthenticatedAppRecordsRoute: AuthenticatedAppRecordsRoute,
    AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute,
    AuthenticatedAppLeadsLeadIdRoute: AuthenticatedAppLeadsLeadIdRoute,
  }

const AuthenticatedAppLayoutRouteWithChildren =
  AuthenticatedAppLayoutRoute._addFileChildren(
    AuthenticatedAppLayoutRouteChildren,
  )

interface AuthenticatedOnboardingLayoutRouteChildren {
  AuthenticatedOnboardingStepRoute: typeof AuthenticatedOnboardingStepRoute
  AuthenticatedOnboardingBillingRoute: typeof AuthenticatedOnboardingBillingRoute
}

const AuthenticatedOnboardingLayoutRouteChildren: AuthenticatedOnboardingLayoutRouteChildren =
  {
    AuthenticatedOnboardingStepRoute: AuthenticatedOnboardingStepRoute,
    AuthenticatedOnboardingBillingRoute: AuthenticatedOnboardingBillingRoute,
  }

const AuthenticatedOnboardingLayoutRouteWithChildren =
  AuthenticatedOnboardingLayoutRoute._addFileChildren(
    AuthenticatedOnboardingLayoutRouteChildren,
  )

interface AuthenticatedSuperadminSettingsLayoutRouteChildren {
  AuthenticatedSuperadminSettingsProfileRoute: typeof AuthenticatedSuperadminSettingsProfileRoute
  AuthenticatedSuperadminSettingsSecurityRoute: typeof AuthenticatedSuperadminSettingsSecurityRoute
  AuthenticatedSuperadminSettingsIndexRoute: typeof AuthenticatedSuperadminSettingsIndexRoute
}

const AuthenticatedSuperadminSettingsLayoutRouteChildren: AuthenticatedSuperadminSettingsLayoutRouteChildren =
  {
    AuthenticatedSuperadminSettingsProfileRoute:
      AuthenticatedSuperadminSettingsProfileRoute,
    AuthenticatedSuperadminSettingsSecurityRoute:
      AuthenticatedSuperadminSettingsSecurityRoute,
    AuthenticatedSuperadminSettingsIndexRoute:
      AuthenticatedSuperadminSettingsIndexRoute,
  }

const AuthenticatedSuperadminSettingsLayoutRouteWithChildren =
  AuthenticatedSuperadminSettingsLayoutRoute._addFileChildren(
    AuthenticatedSuperadminSettingsLayoutRouteChildren,
  )

interface AuthenticatedSuperadminLayoutRouteChildren {
  AuthenticatedSuperadminSettingsLayoutRoute: typeof AuthenticatedSuperadminSettingsLayoutRouteWithChildren
  AuthenticatedSuperadminActivityRoute: typeof AuthenticatedSuperadminActivityRoute
  AuthenticatedSuperadminAnalyticsRoute: typeof AuthenticatedSuperadminAnalyticsRoute
  AuthenticatedSuperadminBillingRoute: typeof AuthenticatedSuperadminBillingRoute
  AuthenticatedSuperadminOrganizationsRoute: typeof AuthenticatedSuperadminOrganizationsRoute
  AuthenticatedSuperadminUsersRoute: typeof AuthenticatedSuperadminUsersRoute
  AuthenticatedSuperadminIndexRoute: typeof AuthenticatedSuperadminIndexRoute
}

const AuthenticatedSuperadminLayoutRouteChildren: AuthenticatedSuperadminLayoutRouteChildren =
  {
    AuthenticatedSuperadminSettingsLayoutRoute:
      AuthenticatedSuperadminSettingsLayoutRouteWithChildren,
    AuthenticatedSuperadminActivityRoute: AuthenticatedSuperadminActivityRoute,
    AuthenticatedSuperadminAnalyticsRoute:
      AuthenticatedSuperadminAnalyticsRoute,
    AuthenticatedSuperadminBillingRoute: AuthenticatedSuperadminBillingRoute,
    AuthenticatedSuperadminOrganizationsRoute:
      AuthenticatedSuperadminOrganizationsRoute,
    AuthenticatedSuperadminUsersRoute: AuthenticatedSuperadminUsersRoute,
    AuthenticatedSuperadminIndexRoute: AuthenticatedSuperadminIndexRoute,
  }

const AuthenticatedSuperadminLayoutRouteWithChildren =
  AuthenticatedSuperadminLayoutRoute._addFileChildren(
    AuthenticatedSuperadminLayoutRouteChildren,
  )

interface AuthenticatedLayoutRouteChildren {
  AuthenticatedAppLayoutRoute: typeof AuthenticatedAppLayoutRouteWithChildren
  AuthenticatedOnboardingLayoutRoute: typeof AuthenticatedOnboardingLayoutRouteWithChildren
  AuthenticatedSuperadminLayoutRoute: typeof AuthenticatedSuperadminLayoutRouteWithChildren
  AuthenticatedBillingReturnRoute: typeof AuthenticatedBillingReturnRoute
}

const AuthenticatedLayoutRouteChildren: AuthenticatedLayoutRouteChildren = {
  AuthenticatedAppLayoutRoute: AuthenticatedAppLayoutRouteWithChildren,
  AuthenticatedOnboardingLayoutRoute:
    AuthenticatedOnboardingLayoutRouteWithChildren,
  AuthenticatedSuperadminLayoutRoute:
    AuthenticatedSuperadminLayoutRouteWithChildren,
  AuthenticatedBillingReturnRoute: AuthenticatedBillingReturnRoute,
}

const AuthenticatedLayoutRouteWithChildren =
  AuthenticatedLayoutRoute._addFileChildren(AuthenticatedLayoutRouteChildren)

interface AuthLayoutRouteChildren {
  AuthAccessDisabledRoute: typeof AuthAccessDisabledRoute
  AuthActionRoute: typeof AuthActionRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthReviewerRoute: typeof AuthReviewerRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthAccessDisabledRoute: AuthAccessDisabledRoute,
  AuthActionRoute: AuthActionRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthReviewerRoute: AuthReviewerRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedLayoutRoute: AuthenticatedLayoutRouteWithChildren,
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  ImpersonateRoute: ImpersonateRoute,
  InvitationInvitationIdRoute: InvitationInvitationIdRoute,
  OauthConsentRoute: OauthConsentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
